import { auth } from "~/plugins/firebase"

export const fetchSignInMethods = (email: string) => {
  return auth.fetchSignInMethodsForEmail(email)
}
